import { cdnCommonPath } from "@/constants/cdnUrls";
import Image from "next/image";
import ExpandableTextSection from "./ExpandableTextSection";

export default function DynamicExpandableSection({
  title,
  text,
  showTurnaLogo = false,
  sectionClassName = "",
  contentClassName = "",
  turnaLogoClassName = "pointer-events-none absolute right-0 -bottom-[26px] opacity-10",
  turnaLogoWidth = 273,
  turnaLogoHeight = 200,
}) {
  return (
    <div className={sectionClassName}>
      <div className={contentClassName}>
        <ExpandableTextSection title={title} text={text} />
        {showTurnaLogo && (
          <Image
            src={`${cdnCommonPath}turna-wings-bg.svg`}
            alt="Turna Background Logo"
            className={turnaLogoClassName}
            width={turnaLogoWidth}
            height={turnaLogoHeight}
          />
        )}
      </div>
    </div>
  );
}
